import React from 'react';
import ToolkitComparePage from './toolkit/ToolkitComparePage';

// Sync › project › Toolkit › History & Forecast — ported from the desktop's Balancing › History Forecast. The v5 and
// Opera Cloud HISTORY_FORECAST reports, matched on considered date + record type; every room, person and revenue figure
// compared to within 0.01 (toolkit compare.js history-forecast).

const fmt = (v) => (v == null ? '—' : Number(v).toLocaleString('en-US', { maximumFractionDigits: 2 }));
const COLUMNS = [
    { key: 'date', label: 'Date' },
    { key: 'recTypeDesc', label: 'Record type', render: (r) => r.recTypeDesc || r.recType },
    { key: 'v5RoomsOccupied', label: 'Rooms v5 / Cloud', render: (r) => `${fmt(r.v5RoomsOccupied)} / ${fmt(r.cloudRoomsOccupied)}` },
    { key: 'v5Revenue', label: 'Revenue v5 / Cloud', render: (r) => `${fmt(r.v5Revenue)} / ${fmt(r.cloudRevenue)}` },
    { key: 'differences', label: 'Differences' },
];
const STATUSES = [{ value: 'partial', label: 'Partial match' }, { value: 'missing', label: 'Missing in Cloud' }];
const summaryOf = (s) => [
    { label: 'v5 rows', value: s.v5Total }, { label: 'Cloud rows', value: s.cloudTotal },
    { label: 'Match', value: s.match, tone: 'ok' }, { label: 'Partial', value: s.partial, tone: 'warn' },
    { label: 'Missing in Cloud', value: s.missing, tone: 'fail' },
];

const ToolkitHistoryForecastPage = () => (
    <ToolkitComparePage title="History & Forecast"
        subtitle="Compare the v5 History & Forecast report with Opera Cloud's, day by day and figure by figure."
        kind="history-forecast" accept=".xml,.rep" exportName="History_Forecast"
        v5Title="Opera v5 History & Forecast" v5Label="Choose the v5 HISTORY_FORECAST (XML)"
        cloudTitle="Opera Cloud History & Forecast" cloudLabel="Choose the Cloud HISTORY_FORECAST (XML)"
        columns={COLUMNS} statuses={STATUSES} summaryOf={summaryOf} />
);

export default ToolkitHistoryForecastPage;
